import Image from 'next/image'
import { useState } from 'react'

type Props = Readonly<{
  trackName: string
  trackImage: string
  videoPreviewMp4: string | null
}>

export function GameCardBackgroundImage({ trackName, trackImage, videoPreviewMp4 }: Props) {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false)
  const hasVideoPreview = Boolean(videoPreviewMp4)

  const handleVideoLoad = () => {
    setIsVideoLoaded(true)
  }

  return (
    <div className="entry-image-container">
      <Image
        alt={`${trackName} Thumbnail`}
        className={`track-image ${hasVideoPreview && isVideoLoaded ? 'opacity-0' : 'opacity-100'}`}
        draggable="false"
        height={320}
        priority
        sizes="100vw"
        src={trackImage}
        style={{ objectFit: 'cover' }}
        width={400}
      />

      {hasVideoPreview && (
        <video
          autoPlay
          className={`track-video ${isVideoLoaded ? 'opacity-100' : 'opacity-0'}`}
          controlsList="nodownload"
          disablePictureInPicture
          loop
          muted
          onLoadedData={handleVideoLoad}
          playsInline
          src={videoPreviewMp4!}
        />
      )}
    </div>
  )
}
